import Row from 'react-bootstrap/Row';
import React from "react";
import Button from "react-bootstrap/Button";
import Col from 'react-bootstrap/Col';
import MyPoints from '../../images/myPointsImage.png';
import MyProgress from '../../images/progressImage.png';
import SiliconeCase from '../../images/SiliconeCaseImage.png';
import IQOSCap from '../../images/IQOSCapBlueImage.png';
function MyRewards() {
    return (
        <div>

            <div style={{
                marginTop: '40px',
                marginBottom: '40px'
            }}>
                <img src={MyPoints} style={{ width: '359px', height: '' }} alt="" />
            </div>

            <div style={{
                marginBottom: '80px'
            }}>
                <img src={MyProgress} style={{ width: '359px', height: '398px' }} alt="" />
            </div>
            <div>
                <div style={{
                    marginBottom: '30px'
                }}>


                    <span style={{
                        fontFamily: 'Sintony',
                        color: '#475666',
                        fontSize: '14px',
                        fontWeight: '700',
                        marginBottom: '30px'

                    }}
                    >MY REWARDS</span>
                </div>
                <Row style={{
                    paddingRight: '10px',
                    marginTop: '10px',
                    marginBottom: '10px'
                }}>
                    <Col style={{
                        paddingBottom: '10px'
                    }}>
                        <img src={SiliconeCase} style={{ width: '92px', height: '92px' }} alt="" />
                    </Col>
                    <Col styele={{
                        fontFamily: 'Sintony',
                        fontSize: '12px',
                        fontWeight: '400',
                        color: '#475666',
                        marginRight: '33px',
                        marginTop: '20px'


                    }}>Silicone Case
                        Color: Yellow</Col>
                    <Col style={{

                        marginTop: '25px'
                    }}> <Button variant="success" size="lg" type="submit" style={{
                        height: '43px',
                        width: '110px',
                        fontSize: '12px',
                        borderRadius: '0',
                        color: '#FFFFFF',
                        borderColor: '#FFFFFF',
                        fontFamily: 'Sintony',
                        backgroundColor: '#00A78A'

                    }} >
                            VIEW ORDER
                        </Button></Col>
                </Row>
                <hr style={{
                    width: '95%'
                }}></hr>
                <Row style={{
                    paddingRight: '10px',
                    marginTop: '10px',
                    marginBottom: '10px'
                }}>
                    <Col>
                        <img src={IQOSCap} style={{ width: '92px', height: '92px' }} alt="" />
                    </Col>
                    <Col styele={{
                        fontFamily: 'Sintony',
                        fontSize: '12px',
                        fontWeight: '400',
                        color: '#475666',
                        marginRight: '20px',
                        marginTop: '15px'


                    }} >IQOS Cap
                        Color: Blue</Col>
                    <Col style={{
                        marginTop: '25px'
                    }}>
                        <Button variant="success" size="lg" type="submit" style={{
                            height: '43px',
                            width: '110px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF',
                            fontFamily: 'Sintony',
                            backgroundColor: '#00A78A'

                        }} >
                            VIEW ORDER
                        </Button>
                    </Col>
                </Row>
                <hr style={{
                    width: '95%'
                }}></hr>
            </div>

        </div>
    );
}

export default MyRewards;